module.exports = __webpack_public_path__ + "img/weifang.ca83f17b.jpg";